/**
 * CategoryBadge — Display work/personal category with confidence indicator
 *
 * Display rules:
 * - >= 98% confidence: Show badge only
 * - 70-97% confidence: Show badge + percentage
 * - < 70% confidence: Show "Unknown" with prompt to classify
 * - User-set: Show badge + "(set by you)", no percentage
 */

import React from 'react';

function CategoryBadge({ category, confidence, source }) {
  const isUserSet = source === 'user';

  // Determine what to display
  let displayLabel = category;
  let showConfidence = false;
  let badgeClass = category;

  if (!category || (!isUserSet && !(confidence >= 0.7))) {
    // Also covers a missing/zero confidence — the backend returns 0 when it
    // had no text to work from, and `undefined < 0.7` used to slip through
    // and print a category the classifier never actually committed to.
    displayLabel = 'Uncategorized';
    badgeClass = 'unknown';
  } else if (!isUserSet && confidence < 0.98) {
    showConfidence = true;
  }

  const confidenceText = showConfidence
    ? Math.round(confidence * 100) + '%'
    : isUserSet
    ? '(set by you)'
    : '';

  const title = badgeClass === 'unknown'
    ? 'No category yet — open the recording and set one'
    : isUserSet
      ? 'Category set by you'
      : `Auto-classified with ${Math.round((confidence || 0) * 100)}% confidence`;

  return (
    <span className={`rp-category-badge ${badgeClass}`} title={title}>
      {displayLabel.charAt(0).toUpperCase() + displayLabel.slice(1)}
      {confidenceText && (
        <span className="rp-category-confidence">{confidenceText}</span>
      )}
    </span>
  );
}

export default CategoryBadge;
